import type { ReactNode } from "react";


export function Metric({ label, value, tone }: { label: string; value: string; tone: string }) {
  return (
    <div className={`metric ${tone}`}>
      <span>{label}</span>
      <strong>{value}</strong>
    </div>
  );
}

export function PanelHeader({ icon, title, code }: { icon: ReactNode; title: string; code: string }) {
  return (
    <div className="panel-header">
      <span className="panel-title">
        {icon}
        {title}
      </span>
      <span className="panel-code">{code}</span>
    </div>
  );
}

export function Select({
  label,
  value,
  values,
  onChange,
  formatValue
}: {
  label: string;
  value: string;
  values: string[];
  onChange: (value: string) => void;
  formatValue?: (value: string) => string;
}) {
  return (
    <label>
      {label}
      <select value={value} onChange={(event) => onChange(event.target.value)}>
        {values.length === 0 && <option value="">--</option>}
        {values.map((item) => (
          <option key={item} value={item}>
            {selectOptionLabel(item, formatValue)}
          </option>
        ))}
      </select>
    </label>
  );
}

function selectOptionLabel(value: string, formatValue: ((value: string) => string) | undefined): string {
  if (formatValue) {
    return formatValue(value);
  }
  return value;
}

export function StatusLamp({ active, warn = false }: { active: boolean; warn?: boolean }) {
  return <span className={`lamp ${statusLampClassName(active, warn)}`} />;
}

function statusLampClassName(active: boolean, warn: boolean): string {
  if (active) {
    return "active";
  }
  if (warn) {
    return "warn";
  }
  return "";
}
